export default __webpack_public_path__ + "static/media/ITER_GR6.1458db05.96f1ad77.pdf";